module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1054.d0b32073.png";